import {
  AKIAcceptancesApi,
  AKIAcuteKidneyInjuryPluginApi,
  AkiOverviewControllerApi,
  type AkiInfoPanelDTO,
  type AkiOverviewResponseDTO,
  type PluginAcceptanceRequest,
  type PluginUdiDto
} from '@/generated'
import { globalApiConfig } from '@/services/telehealthApi/APIConfig'

export class AkiPredictionsService {
  static readonly akiOverviewApi = new AkiOverviewControllerApi(globalApiConfig)
  static readonly akiApi = new AKIAcuteKidneyInjuryPluginApi(globalApiConfig)
  static readonly acceptancesApi = new AKIAcceptancesApi(globalApiConfig)

  static async getAkiOverview({
    page = 0,
    size = 10,
    sort
  }: {
    page?: number
    size?: number
    sort?: string[]
  } = {}): Promise<AkiOverviewResponseDTO> {
    return (await AkiPredictionsService.akiOverviewApi.getAkiOverview(page, size, sort)).data
  }

  static async isAkiFeatureEnabled(): Promise<boolean> {
    try {
      const response = await AkiPredictionsService.akiOverviewApi.isAkiWidgetEnabled()
      return response.status >= 200 && response.status < 300 && response.data
    } catch (e) {
      return false
    }
  }

  static async getUdi(): Promise<PluginUdiDto> {
    return (await AkiPredictionsService.akiApi.getUdi1()).data
  }

  static async getAkiInfoPanel(caseId: string): Promise<AkiInfoPanelDTO> {
    return (await AkiPredictionsService.akiOverviewApi.getAkiInfoPanel(caseId)).data
  }

  static async acceptAkiLimitation(payload: PluginAcceptanceRequest): Promise<void> {
    return (await AkiPredictionsService.acceptancesApi.accept1(payload)).data
  }
}
